import { PRODUCT_SEARCH_QUERY_PARAMS } from '@/lib/query-params';
import { EXCLUSIVE_REFINEMENT_ATTRIBUTE_IDS } from './types';

export function computeNextRefines(currentRefines: string[], attributeId: string, value: string): string[] {
    const refinePair = `${attributeId}=${value}`;
    if (currentRefines.includes(refinePair)) {
        return currentRefines.filter((r) => r !== refinePair);
    }
    if ((EXCLUSIVE_REFINEMENT_ATTRIBUTE_IDS as readonly string[]).includes(attributeId)) {
        return [...currentRefines.filter((r) => !r.startsWith(`${attributeId}=`)), refinePair];
    }
    return [...currentRefines, refinePair];
}

export function applyRefinesToSearchParams(params: URLSearchParams, nextRefines: string[]): void {
    params.delete(PRODUCT_SEARCH_QUERY_PARAMS.REFINE);
    nextRefines.forEach((r) => params.append(PRODUCT_SEARCH_QUERY_PARAMS.REFINE, r));
    params.delete(PRODUCT_SEARCH_QUERY_PARAMS.PAGE);
}
